import { render, staticRenderFns } from "./address-push.vue?vue&type=template&id=64a994ec&scoped=true"
import script from "./address-push.vue?vue&type=script&lang=js"
export * from "./address-push.vue?vue&type=script&lang=js"
import style0 from "./address-push.vue?vue&type=style&index=0&id=64a994ec&prod&lang=css"
import style1 from "./address-push.vue?vue&type=style&index=1&id=64a994ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a994ec",
  null
  
)

export default component.exports